import React from 'react';
import { Col, Row } from 'react-bootstrap';

import baseballIcon from 'images/insights/baseball_icon.png';
import booksIcon from 'images/insights/books_icon.png';
import briefcaseIcon from 'images/insights/briefcase_icon.png';
import buildingIcon from 'images/insights/building_icon.png';
import earthIcon from 'images/insights/earth_icon.png';
import footballIcon from 'images/insights/football_icon.png';
import palmTreeIcon from 'images/insights/palm_tree_icon.png';
import pencilIcon from 'images/insights/pencil_icon.png';
import skillsIcon from 'images/insights/skills_icon.png';
import televisionlIcon from 'images/insights/television_icon.png';

import { useEventTracking } from '@hooks';
import useCurrentUser from '@hooks/useCurrentUser';
import { Page } from '@tracking';

import InsightSection from './InsightSection';
import UpdateProfileButton from './UpdateProfileButton';
import './styles.module.scss';
import styles from './styles.module.scss';

const RELATIONSHIP_SOURCE_USER_ACTION = 'user_action';
const RELATIONSHIP_TYPE_FOLLOWS = 'follows';
const RELATIONSHIP_SOURCE_TI_PROFILE = 'ti_profile';
const MEMBER_FAVORITES_MAP = [
  {
    title: 'Favorite TV Shows/Movies',
    relationshipSource: RELATIONSHIP_SOURCE_TI_PROFILE,
    relationshipType: 'favorite_show',
    icon: televisionlIcon,
    searchAttribute: 'favorite_show',
  },
  {
    title: 'Favorite Books',
    relationshipSource: RELATIONSHIP_SOURCE_TI_PROFILE,
    relationshipType: 'favorite_book',
    icon: booksIcon,
    searchAttribute: 'favorite_book',
  },
  {
    title: 'Favorite Vacation Spots',
    relationshipSource: RELATIONSHIP_SOURCE_TI_PROFILE,
    relationshipType: 'favorite_vacation_spot',
    icon: palmTreeIcon,
    searchAttribute: 'favorite_vacation_spots',
  },
  {
    title: 'Favorite Sports to Play',
    relationshipSource: RELATIONSHIP_SOURCE_TI_PROFILE,
    relationshipType: 'favorite_sport_play',
    icon: baseballIcon,
    searchAttribute: 'favorite_sport_play',
  },
  {
    title: 'Favorite Sports to Watch',
    relationshipSource: RELATIONSHIP_SOURCE_TI_PROFILE,
    relationshipType: 'favorite_sport_watch',
    icon: footballIcon,
    searchAttribute: 'favorite_sport_watch',
  },
];
const MEMBER_INSIGHTS_MAP = [
  {
    title: 'Companies',
    relationshipSource: RELATIONSHIP_SOURCE_TI_PROFILE,
    relationshipType: 'company_name',
    icon: buildingIcon,
    searchAttribute: 'company',
  },
  {
    title: 'Locations',
    relationshipSource: RELATIONSHIP_SOURCE_TI_PROFILE,
    relationshipType: 'location',
    icon: earthIcon,
    searchAttribute: 'location',
  },
  {
    title: 'Titles',
    relationshipSource: RELATIONSHIP_SOURCE_TI_PROFILE,
    relationshipType: 'job_title',
    icon: briefcaseIcon,
    searchAttribute: 'list_display',
  },
  {
    title: 'Skills',
    relationshipSource: RELATIONSHIP_SOURCE_TI_PROFILE,
    relationshipType: 'skill',
    icon: skillsIcon,
    searchAttribute: 'skills',
  },
];

const CommunityInsights = () => {
  const { currentUser, isLoadingCurrentUser } = useCurrentUser();
  const { Track } = useEventTracking({ page: Page.CommunityInsights });

  if (!currentUser && !isLoadingCurrentUser) {
    window.location.href = '/';
    return <div></div>;
  }

  return (
    <>
      <div className="container-padded container">
        <main>
          <Track>
            <Row className={styles.headerContainer}>
              <Col className="col-md-8">
                <div className={styles.titleContainer}>
                  <h3 className={styles.headerText}>Community Insights</h3>
                  <p className={styles.secondaryText}>
                    At The Information we have the best community. Want to know what they’re
                    interested in?
                  </p>
                </div>
              </Col>
              <Col className="col-md-4">
                <div className={styles.updateProfileContainer}>
                  Want your info to be included?
                  <UpdateProfileButton />
                </div>
              </Col>
            </Row>
            {/* Member Favorites */}
            <Row className={styles.sectionHeader}>
              <Col className="col-md-12">
                <h3 className={styles.headerText}>Member Favorites</h3>
                <p className={styles.secondaryText}>
                  What’s everybody watching, playing or reading?
                </p>
              </Col>
            </Row>
            <Row>
              {MEMBER_FAVORITES_MAP.map((insightMap) => (
                <InsightSection
                  key={insightMap.title}
                  title={insightMap.title}
                  relationshipSource={insightMap.relationshipSource}
                  relationshipType={insightMap.relationshipType}
                  icon={insightMap.icon}
                  searchAttribute={insightMap.searchAttribute}
                />
              ))}
            </Row>
            {/* Hot Topics */}
            <Row className={styles.sectionHeader}>
              <Col className="col-md-12">
                <h3 className={styles.headerText}>Hot Topics</h3>
                <p className={styles.secondaryText}>What topics are our members interested in?</p>
              </Col>
            </Row>
            <Row>
              <InsightSection
                title="Topics"
                relationshipSource={RELATIONSHIP_SOURCE_USER_ACTION}
                relationshipType={RELATIONSHIP_TYPE_FOLLOWS}
                expand={true}
                icon={pencilIcon}
                searchAttribute="topics"
              />
            </Row>
            {/* Member Insights */}
            <Row className={styles.sectionHeader}>
              <Col className="col-md-12">
                <h3 className={styles.headerText}>Member Insights</h3>
                <p className={styles.secondaryText}>
                  Our members are varied across industries and places.
                </p>
              </Col>
            </Row>
            <Row>
              {MEMBER_INSIGHTS_MAP.map((insightMap) => (
                <InsightSection
                  key={insightMap.title}
                  title={insightMap.title}
                  relationshipSource={insightMap.relationshipSource}
                  relationshipType={insightMap.relationshipType}
                  icon={insightMap.icon}
                  searchAttribute={insightMap.searchAttribute}
                />
              ))}
            </Row>
          </Track>
        </main>
      </div>
    </>
  );
};

export default CommunityInsights;
